import React from 'react';
import { AppStoreContext } from './context';
import { useAppStore } from './store';
import { StoreHooks } from './hooks';

export type AppStoreProviderProps = {
  children: React.ReactNode;
};

export const AppStoreProvider: React.FC<{ children: React.ReactNode }> = (props) => {
  const store = useAppStore();

  // Hooks manipulating the store
  StoreHooks.useUser(store);
  StoreHooks.useCompatibilityInfo(store);
  StoreHooks.useAuthMethods(store);
  StoreHooks.useMainClock(store);
  StoreHooks.useMobileDetection(store);

  return (
    <AppStoreContext.Provider value={store}>
      {props.children}
    </AppStoreContext.Provider>
  );
};
